export class CompanyModel{
  compCode ='' ;
  compName ='' ;
  compAddress ='' ;
  compPhone ='' ;
  compContact ='' ;
  compUser1 ='' ;
  compUser2 ='' ;
  compUserNumb ='' ;
  compUserDate ='' ;
  compPath ='' ;
  userID ='sa' ;
  modifaiedDate = '2021-01-01';
}
